import { trpc } from './trpc';

/** Validates WooCommerce API keys before any Tagada store exists. */
export function useValidateWoocommerceConnection() {
  return trpc.integrations.validateWoocommerceConnection.useMutation();
}
